import { hasRoles } from '@/utils/auth';

interface Cancellable {
  state: string;
  transitions: {
    mayCancel: boolean;
  };
}

export const cancelActionPermitted = (bet: Cancellable): boolean => {
  return hasRoles(['sports:operator', 'sports-grading:operator']) &&
    bet.state !== 'cancelled' &&
    bet.transitions.mayCancel;
};
